<template>
  <div
    v-if="
      account.isCoach ||
        account.isRoutineManager ||
        account.canDoFinancialValidation ||
        account.isSiteAdmin ||
        account.isOrganizationAdmin
    "
    class="d-flex flex-wrap align-center"
  >
    <v-chip
      data-testid="directory-chip-isCoach"
      v-if="account.isCoach"
      class="mr-2 mb-2"
      color="blue-grey lighten-1"
      outlined
      small
    >
      <span class="blue-grey--text text--darken-3">{{
        $t('common.roles.coach_one')
      }}</span>
    </v-chip>

    <v-chip
      data-testid="directory-chip-isRoutineManager"
      v-if="account.isRoutineManager"
      class="mr-2 mb-2"
      color="blue-grey lighten-1"
      outlined
      small
    >
      <span class="blue-grey--text text--darken-3">{{
        $t('common.roles.routine_manager')
      }}</span>
    </v-chip>

    <v-chip
      data-testid="directory-chip-financialCoach"
      v-if="account.canDoFinancialValidation"
      class="mr-2 mb-2"
      color="blue-grey lighten-1"
      outlined
      small
    >
      <span class="blue-grey--text text--darken-3">{{
        $t('common.roles.impact_validator')
      }}</span>
    </v-chip>

    <v-chip
      data-testid="directory-chip-siteAdmin"
      v-if="account.isSiteAdmin"
      class="mr-2 mb-2"
      color="blue-grey lighten-1"
      outlined
      small
    >
      <span class="blue-grey--text text--darken-3">{{
        $t('common.roles.site_admin')
      }}</span>
    </v-chip>

    <v-chip
      data-testid="directory-chip-orgAdmin"
      v-if="account.isOrganizationAdmin"
      class="mr-2 mb-2"
      color="blue-grey lighten-1"
      outlined
      small
    >
      <span class="blue-grey--text text--darken-3">{{
        $t('common.roles.organization_admin')
      }}</span>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'UserRoleChips',

  props: {
    account: {
      type: Object,
      required: true,
    },
  },
}
</script>
